<template>
  <div class="tab_menu" :class="{'purchase': isPurchase}">
    <div v-for="tab in tabs" :key="tab.id"
        class="tab"
        :class="{ active: activeTab === tab.id ,'purchase': isPurchase}"
        @click="changeTab(tab)">
      {{ t(tab.label) }}
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  mixins: [t],
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    isPurchase: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeTab(tab) {
      this.$emit('update-activeTab', tab.id);
      if (tab.route) {
        this.$router.push({ path: tab.route });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_menu {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #ffffff;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  &.purchase {
    align-items: center;
  }
  .tab {
    white-space: nowrap;
    font-weight: bold;
    padding: 5px 30px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    box-sizing: border-box;
    color: #555;
    border-radius: 10px;
    &.purchase {
      white-space: inherit;
    }
  }
  .tab.active {
    padding: 5px 30px;
    border-radius: 10px;
    background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
    color: #fff;
    outline: none;
    box-shadow: 0 2px 8px rgba(42, 112, 184, 0.4);
  }
}
@media screen and (max-width: $tabletWidth) {
  .tab_menu {
    .tab {
      font-size: 15px !important;
      padding: 5px 20px !important;
      &.purchase {
        padding: 5px 10px !important;
      }
    }
    .tab.active {
      padding: 5px 20px !important;
      &.purchase {
        padding: 5px 10px !important;
      }
    }
  }
}
</style>
